/**
 * DiscoverIcon/index.js
 * desc: discover feature main navigation icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DiscoverIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="discover icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.discover.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M0 7c0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.38-1.19 4.47-3 5.74V15c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-2.26C1.19 11.47 0 9.38 0 7zm5 13c-.55 0-1-.45-1-1v-1h6v1c0 .55-.45 1-1 1H5z"/></svg>
    </IconButton>
);


export default DiscoverIcon;
